import { useEvaluationData } from "../../contexts/EvaluationContext";
import FloatingCircle from "../FloatingCircle/FloatingCircle";
import "./Evaluation.css";

// — STEP 1: Athlete Intro —
const EvaluationIntro = ({ onSubmit }) =>{

  const { evalData, dispatch } = useEvaluationData();

  // Destructure demographics options
  const {
    ageRangeOptions,
    sportSeasonOptions,
    genderOptions,
    athleteLevelOptions
  } = evalData.demographics;


  const handleSubmitButton = e => {
    e.preventDefault();
    onSubmit();
  };
  
  const customText = (
    <div>
      <p>
        Tell us about your current experience.
      </p>
      <p>
        Please answer based on how things feel right now in the sport organization that sent you this.
      </p>
      {/* <p>
        If you encounter any abusive content, please let us know—you can file
        a report here or review our policy.
      </p> */}
      {/* add links/buttons as needed */}
    </div>
  );

  return (
    <>
    <div className="evaluation-step-container">
      <h2>Athlete Wellness Evaluation</h2>
      <p>Created by athletes and clinicians, this survey helps identify what athletes need—while keeping you fully anonymous</p>
      <p>
        You’ll answer questions about mental, emotional, physical, and social support in your sport environment.
      </p>
      <p className="description">
        Your responses are combined with teammates’ to reflect team culture. If you want to share more, contact your org’s safeguarding lead or the {" "}
        <a
          className="athlete-helpline"
          href="https://www.athletehelpline.org/"
        >
           U.S Athlete Helpline
        </a>{" "}
      </p>
      <br />
      <p>If you are under 18, please have a parent assist in this evaluation of a minor.</p>
      <form onSubmit={handleSubmitButton}>
        <div className="dropdown-container">
          <label>Age Range:</label>
          <select
            className="styled-select"
            value={evalData.demographics.ageRange}
            onChange={e => dispatch({
                type: "SET_DEMOGRAPHSIC_FIELD",
                field: "ageRange",
                value: e.target.value
              })
            }
            required
          >
            <option value="">Select Age Range</option>
            {ageRangeOptions.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
        <div className="dropdown-container">
          <label>Sport Season:</label>
          <select
            className="styled-select"
            value={evalData.demographics.sportSeason}
            onChange={e => 
                dispatch({
                  type: "SET_DEMOGRAPHSIC_FIELD", 
                  field: "sportSeason",
                  value: e.target.value 
                })
            }
            required
          >
            <option value="">Select Season</option>
            {sportSeasonOptions.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
        <div className="dropdown-container">
          <label>Gender:</label>
          <select
            className="styled-select"
            value={evalData.demographics.gender}
            onChange={e => dispatch({
              type: "SET_DEMOGRAPHSIC_FIELD", 
              field: "gender", 
              value: e.target.value
            })}
            required
          >
            <option value="">Select Gender</option>
            {genderOptions.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
        <div className="dropdown-container">
          <label>Athlete Level:</label>
          <select
            className="styled-select"
            value={evalData.demographics.athleteLevel}
            onChange={e => dispatch({
                type: "SET_DEMOGRAPHSIC_FIELD",
                field: "athleteLevel",
                value: e.target.value
            })}
            required
          >
            <option value="">Select Level</option>
            {athleteLevelOptions.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
        <div className="evaluation-button-section">

        <button type="submit" className="evaluation-button">Start Evaluation</button>
        </div>
      </form>
    </div>
    <FloatingCircle
        modalTitle="Notice"
        modalContent={customText}
        openModal={true}
    />
    </>
  );
}

export default EvaluationIntro;
